import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { HttpService, MessageService } from 'brainloper-ui';
import { User } from 'app/models2/administration/user';
import { BaseResponse } from 'app/models2/commos/base-response';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { IValidateIfUserExists, ValidateIfUserExists } from 'app/models2/administration/validateIfUserExists';
import { IValidateIfEmailExists, ValidateIfEmailExists } from 'app/models2/administration/validateIfEmailExists';

@Injectable({
  providedIn: 'root'
})
export class UserServiceService {

  private urlPostUser: string = `${EndpointDictionary.User.CRUD_USER_DATA}`
  private urlUploadFile : string = `${EndpointDictionary.Docs.DOCS_SUBIR}`;

  constructor(
    private message: MessageService,
    private http: HttpService,
    private router: Router,

  ) { }

  public async addUser(form:User, files){
    this.message.openLoading('Cargando', 'Guardando usuario')
    if(!form.phone) form.phone = 0
    if (files.photo != null) {
      let formFoto: FormData = this.crearFormularioMultipart(files.photo)
      let res: string  = await this.saveFile(formFoto)
      form.photo = res
    } else {
      console.log('no se cargo foto cv')
    }

    if (files.cv != null) {
      let formCv: FormData = this.crearFormularioMultipart(files.cv)
      let res: string  = await this.saveFile(formCv)
      form.cv = res
    } else {
      console.log('no se cargo ninguana cv')
    }

    this.http.postData(this.urlPostUser, form).subscribe(
      (res: BaseResponse<GenericResponse>) => {
        // //console.log(res)
        if (res['code'] === 0) {
          this.message.closeLoading()
          this.message.SuccessToast('Usuario creado correctamente')
          setTimeout(() => {
            this.router.navigate(['administracion/usuarios'])
          }, 1000);
        } else {
          this.message.closeLoading()
          this.message.Error('Error!', `Código: ${res['code']} - Mensaje : ${res['body']['sqlMessage']}`)
        }
      },
      err => {
        this.message.closeLoading()
        this.message.Error('Error!', err.message)
      }
    )

  }

  public async updateUser(form:User, files, fotoPH:string, cvPH:String){
    this.message.openLoading('Cargando', 'Actualizando usuario')
    if (files.photo == fotoPH) {
      //console.log('no se actualizo la foto')
    } else {
      let formFoto: FormData = this.crearFormularioMultipart(files.photo, fotoPH)
      form.photo = await this.saveFile(formFoto)
      //console.log('se actualizo la foto')
    }
    if (files.cv == cvPH) {
      //console.log('no se actualizo el cv')
    } else {
      let formCv: FormData = this.crearFormularioMultipart(files.cv, cvPH)
      form.cv = await this.saveFile(formCv)
      //console.log('se actualizo el cv')
    }

    this.http.putData(this.urlPostUser, form).subscribe(
      (res: BaseResponse<GenericResponse>) => {

        ////console.log(res)
        if (res['code'] === 0) {
          this.message.closeLoading()
          this.message.SuccessToast('Usuario actualizado correctamente')
          setTimeout(() => {
            this.router.navigate(['administracion/usuarios'])
          }, 1000);
        } else {
          this.message.closeLoading()
          this.message.Error('Error!', `Código: ${res['code']} - Mensaje : ${res['body']['sqlMessage']}`)
        }
      },
      err => {
        this.message.closeLoading()
        this.message.Error('Error!', err.message)
      }
    )
  }

  private crearFormularioMultipart(file: File, old?) {

    const formD = new FormData();
    formD.append('file', file, 'form-data');//Asigna el campo File
    if (old) {
      formD.append('old', old);//Asigna el campo File
    }
    return (formD)

  }

  private saveFile(form) : Promise<string> {
    return new Promise((resolve, reject) => {
      this.http.postData(this.urlUploadFile, form).subscribe(
        (res: BaseResponse<string>) => {
          if (res['code'] === 0) {
            resolve(res['body'])
          } else {
            this.message.Error("Error", res["message"])
            reject(null)
          }
        },
        err => {
          this.message.Error("Error", "Error del sistema")
          reject(null)
        }
      )
    })
  }

  public async validateUser(user: string):Promise<ValidateIfUserExists> {
    let validateIfUserExists = new ValidateIfUserExists()
    let res: IValidateIfUserExists =
      await this.http.getDataBody(
        `${EndpointDictionary.User.VALIDATE_IF_USER_EXISTS}/${user}`
      );
    if (res) {

      validateIfUserExists = res;

      if (validateIfUserExists.userExistsInCurrentCompany) {
        this.message.Error('Error', `El usuario ${user} ya existe en esta compañía`);
        return (validateIfUserExists)
      }

      if(validateIfUserExists.userExists){
        this.message.Error('Error', `El usuario ${user} ya existe en otra compañía por lo tanto no le puede asignar una contraseña`);
      }

    }
    return (validateIfUserExists)
  }

  public async validateEmail(email: string, currentUserId?: number, showMessage: boolean = true):Promise<ValidateIfEmailExists> {
    let validateIfEmailExists = new ValidateIfEmailExists()
    let res: IValidateIfEmailExists =
      await this.http.getDataBody(
        `${EndpointDictionary.User.VALIDATE_IF_EMAIL_EXISTS}/${email}`
      );
    if (res) {
      validateIfEmailExists = res;

      // Si es una actualización y el email pertenece al mismo usuario, permitir
      if (currentUserId && validateIfEmailExists.userId === currentUserId) {
        validateIfEmailExists.emailExists = false;
        return validateIfEmailExists;
      }

      if (validateIfEmailExists.emailExists && showMessage) {
        this.message.Error('Error', `El correo electrónico ${email} ya está registrado por otro usuario`);
      }
    }
    return validateIfEmailExists;
  }

}
